var _rect, _path, _path2, _path3, _path4, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _circle5, _circle6, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1677,
    height: 896,
    viewBox: "0 0 1677 896",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1677,
    height: 896,
    fill: "#ADB0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M913.178 282.962C913.982 281.16 915.771 280 917.743 280H989.757C991.729 280 993.518 281.16 994.322 282.962L1002.36 300.962C1003.83 304.269 1001.41 308 997.792 308H909.708C906.086 308 903.666 304.269 905.142 300.962L913.178 282.962Z",
    fill: "#253E52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M682.178 282.962C682.982 281.16 684.771 280 686.743 280H758.757C760.729 280 762.518 281.16 763.322 282.962L771.358 300.962C772.834 304.269 770.414 308 766.792 308H678.708C675.086 308 672.666 304.269 674.142 300.962L682.178 282.962Z",
    fill: "#253E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M687 593L675 608L670 613.5L662.5 620.5L653.5 628L645 633.5L636.5 638L628.5 641.5L618 644L610 645.5H602H590.5L582 644L572.5 640L564.5 634.5L558.5 628L553 617.5L548 604L545.5 591.5L544 575.5V560.5L545.5 543.5L548 522.5L551.5 501L555.5 480.5L560.5 458.5L566.5 436L571.5 418.5L576.5 402L582 385.5L587.5 368.5L593 354L599 341.5L609 329L617 322L626.5 315L636 310L649.5 305L662.5 303H688.5H1002H1017.5L1029 305.5L1039.5 310L1050.5 316L1061.5 323.5L1071.5 333L1078 341.5L1082.5 350.5L1088.5 367.5L1094 382.5L1099 398.5L1104 415.5L1109.5 432L1113 446.5L1117 461L1120.5 475.5L1124 490L1127.5 507.5L1129.5 524L1132 540L1133.5 553V565.5V581.5L1132 591.5L1129.5 602L1126.5 613L1121 624L1114 633L1106.5 639L1097.5 644L1087.5 645.5H1082H1072L1057 644L1043.5 640L1029 632L1018 624L1005.5 611.5L992.5 597L980.5 583L969.5 570L955 554.5L937 539L919 526.5L901.5 518.5L882 511L863.5 508L853 507.5H825.5L816.5 508L801.5 511L784.5 515.5L768.5 522L755.5 528.5L743.5 536L732 545.5L720 556L707.5 569L696.5 581.5L687 593Z",
    fill: "#253E52",
    stroke: "#253E52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M627 600L619 601H608.5L600.5 600.5L593.5 599L589 597.5L584.5 594L580 589.5L574 578L570 563.5L569.5 549.5V526.5L571 502L572.5 483.5L575 461.5L578.5 442.5L581.5 427.5L584 415L587 403.5L590 391L592.5 378.5L595.5 364L599 350.5L604 339.5L608 331.5L617.5 322L627.5 315.5L637 310L647.5 306.5L657.5 304L671.5 303H983.5H1008H1017.5L1029 305.5L1040.5 310.5L1050.5 316L1055 319L1060.5 323L1064.5 326.5L1071.5 336L1078 348.5L1082.5 365.5L1091 402.5L1100 449L1105 480.5L1109 512V546.5V568.5L1106 581L1098.5 591L1090 599.5L1077.5 602.5H1065L1050.5 599.5L1034.5 592.5L1019.5 581L1006.5 568.5L992.5 552L975.5 535.5L956.5 518L938 506L920.5 497.5L900 489.5L877.5 484L859 482H840.5H817.5L797.5 484L779 488.5L753 497L734.5 507.5L721 517.5L705 532L691.5 546L671.5 566.5L656.5 581L643.5 591L634.5 596.5L627 600Z",
    fill: "#34526E",
    stroke: "#34526E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 681,
    cy: 413,
    r: 70,
    fill: "#253E52"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 413,
    r: 70,
    fill: "#253E52"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 371,
    width: 49,
    height: 20,
    rx: 3,
    fill: "#253E52"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 851,
    y: 371,
    width: 49,
    height: 20,
    rx: 3,
    fill: "#253E52"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 958,
    cy: 413,
    r: 20,
    fill: "#E84C3D"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 373,
    r: 20,
    fill: "#F2C311"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1038,
    cy: 413,
    r: 20,
    fill: "#16A086"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 998,
    cy: 453,
    r: 20,
    fill: "#3699DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M704.528 394.508C705.469 393.544 706.76 393 708.107 393H735C737.761 393 740 395.239 740 398V428C740 430.761 737.761 433 735 433H708.034C706.73 433 705.477 432.49 704.544 431.58L689.581 416.992C687.603 415.063 687.564 411.897 689.493 409.92L704.528 394.508Z",
    fill: "#34526E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M656.472 394.508C655.531 393.544 654.24 393 652.893 393H626C623.239 393 621 395.239 621 398V428C621 430.761 623.239 433 626 433H652.966C654.27 433 655.523 432.49 656.456 431.58L671.419 416.992C673.397 415.063 673.436 411.897 671.507 409.92L656.472 394.508Z",
    fill: "#34526E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M662.088 388.911C661.127 387.966 660.587 386.674 660.592 385.327L660.681 358.434C660.69 355.673 662.936 353.442 665.697 353.451L695.697 353.55C698.458 353.559 700.689 355.805 700.68 358.566L700.591 385.532C700.587 386.836 700.073 388.087 699.16 389.018L684.522 403.932C682.587 405.903 679.421 405.932 677.45 403.997L662.088 388.911Z",
    fill: "#34526E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M661.93 436.967C660.962 437.905 660.414 439.194 660.409 440.541L660.32 467.434C660.311 470.195 662.543 472.441 665.304 472.45L695.304 472.549C698.065 472.558 700.311 470.327 700.32 467.566L700.409 440.6C700.414 439.296 699.908 438.042 699.001 437.105L684.462 422.094C682.54 420.11 679.374 420.06 677.391 421.982L661.93 436.967Z",
    fill: "#34526E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.1fa2630738dfcffa86380a034ca33e17.svg";
export { ForwardRef as ReactComponent };